import apiClient, { API_BASE_URL } from './client';

const BASE = '/api/v1/live-quiz';

export const liveQuizApi = {
    createSession: (lessonId) =>
        apiClient.post(`${BASE}/sessions`, { lesson_id: lessonId }),

    getSession: (sessionId) =>
        apiClient.get(`${BASE}/sessions/${sessionId}`),

    startSession: (sessionId) =>
        apiClient.post(`${BASE}/sessions/${sessionId}/start`),

    showResults: (sessionId) =>
        apiClient.post(`${BASE}/sessions/${sessionId}/show-results`),

    nextQuestion: (sessionId) =>
        apiClient.post(`${BASE}/sessions/${sessionId}/next-question`),

    getLeaderboard: (sessionId) =>
        apiClient.get(`${BASE}/sessions/${sessionId}/leaderboard`),

    joinSession: (sessionId, displayName) =>
        apiClient.post(`${BASE}/sessions/${sessionId}/join`, { display_name: displayName }),

    submitAnswer: (sessionId, participantId, questionIndex, answer) =>
        apiClient.post(`${BASE}/sessions/${sessionId}/answer`, {
            participant_id: participantId,
            question_index: questionIndex,
            answer,
        }),

    abandonSession: (sessionId) =>
        apiClient.post(`${BASE}/sessions/${sessionId}/abandon`),

    getWsTicket: (sessionId) =>
        apiClient.post(`${BASE}/sessions/${sessionId}/ws-ticket`),

    pollSession: (sessionId, participantId = null) =>
        apiClient.get(`${BASE}/sessions/${sessionId}/poll`, {
            params: participantId ? { participant_id: participantId } : {},
        }),
};

export function buildInstructorWsUrl(sessionId, ticket) {
    const wsBase = API_BASE_URL.replace(/^https?/, (m) => (m === 'https' ? 'wss' : 'ws'));
    return `${wsBase}/api/v1/live-quiz/sessions/${sessionId}/ws/instructor?ticket=${encodeURIComponent(ticket)}`;
}

export function buildStudentWsUrl(sessionId, participantId) {
    const wsBase = API_BASE_URL.replace(/^http/, 'ws');
    return `${wsBase}/api/v1/live-quiz/sessions/${sessionId}/ws/student/${participantId}`;
}

export default liveQuizApi;
